const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozOTUsImNvbmdyZXNzSWQiOjEyMDQsImRhdGUiOiIyMDIwLTA2LTE3VDA2OjExOjA4Ljc2MFoiLCJpYXQiOjE1OTIzNzQyNjh9.XjH4nLJh1evk8ShCFrMxhk0D_9eEfuKYoq6Tb_rKiuw';
const PLANNER_API_URL = 'https://ws2022.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozOTYsImNvbmdyZXNzSWQiOjEyMDQsImRhdGUiOiIyMDIwLTA2LTE3VDA2OjE1OjE1LjI3N1oiLCJpYXQiOjE1OTIzNzQ1MTV9.vdU308hJCJXG5MoadEL-Ao243JFYW01kkc5SZDxHq9E';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1256;
const SUBMISSION_API_URL = 'https://ws2022.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{ids}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  // AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}